import { render, staticRenderFns } from "./SubscribePriority.vue?vue&type=template&id=6f1dccb4&scoped=true&"
import script from "./SubscribePriority.vue?vue&type=script&lang=js&"
export * from "./SubscribePriority.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePriority.vue?vue&type=style&index=0&id=6f1dccb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dccb4",
  null
  
)

export default component.exports